<div class="header">
  <div class="title">Add Deal</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<mat-tab-group>
  <!-- <mat-tab label="Deal Details">
        <form [formGroup]="addProjectForm" *ngIf="isDealsDetailView; else optionalView" (submit)="addProjectForm.pristine || addProjectForm.invalid ? null : save()">

            <div class="flex flex-col mt-3">
                <mat-form-field class="subject flex-auto">
                    <mat-label>Deal Name</mat-label>
                    <input id="add-project-title" matInput
                        placeholder="Enter Deal name"
                        [formControlName]="'title'" (blur)="onBlur()" (keyup.enter)="onBlur()">
                    </mat-form-field>
                    <mat-hint *ngIf="duplicateProjects && duplicateProjects.length > 0" class="mb-3">
                        One or more deals with the same name already exists:
                        <ul>
                            <li *ngFor="let project of duplicateProjects"><a class="link" (click)="goToProject(project)">{{ project.title }}</a></li>
                        </ul>
                    </mat-hint>
            </div>
            <div class="flex flex-col gt-xs:flex-row">
                <mat-form-field class="flex-auto gt-xs:pr-3">
                    <mat-label>Property Type</mat-label>
                    <mat-select id="add-project-property-type" [formControlName]="'property_type_id'" placeholder="--Select--">
                        <mat-option *ngFor="let propertyType of propertyTypes"
                                    [value]="propertyType.id">
                            {{propertyType.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="flex-auto gt-xs:pr-3">
                    <mat-label>Deal Layout</mat-label>
                    <mat-select [formControlName]="'template_id'" placeholder="--Select--">
                        <mat-option *ngFor="let projectTemplate of projectTemplates"
                                    [value]="projectTemplate.id">
                            {{projectTemplate.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <fieldset [formGroupName]="'property'">
                <fieldset [formGroupName]="'address'">
                    <div class="flex flex-col gt-xs:flex-col">
                        <mat-form-field class="flex-auto gt-xs:pr-3">
                            <mat-label>Address</mat-label>
                            <input id="add-project-address" matInput google-place placeholder="Address" [formControlName]="'street'" (onSelect)="setAddress($event)" (onSelectParts)="setAddressParts($event)" [autocomplete]="'off'" (blur)="addressBlur()">
                        </mat-form-field>
                        <mat-hint *ngIf="duplicateAddressProjects && duplicateAddressProjects.length > 0" class="mb-3">
                            One or more deals with the same address already exists:
                            <ul>
                                <li *ngFor="let project of duplicateAddressProjects"><a class="link" (click)="goToProject(project)">{{ project.title }}</a></li>
                            </ul>
                        </mat-hint>
                    </div>
                    <div class="flex flex-col gt-xs:flex-row">
                        <mat-form-field class="flex-auto gt-xs:pr-3">
                            <mat-label>City</mat-label>
                            <input id="add-project-city" matInput [formControlName]="'city'" placeholder="City" (blur)="addressBlur()">
                        </mat-form-field>
                        <mat-form-field class="flex-auto gt-xs:pr-3">
                            <mat-label>State</mat-label>
                            <input id="add-project-state" matInput [formControlName]="'state'" placeholder="State" (blur)="addressBlur()">
                        </mat-form-field>
                        <mat-form-field class="flex-auto gt-xs:pr-3">
                            <mat-label>Zip</mat-label>
                            <input id="add-project-zip" matInput [formControlName]="'postal_code'" placeholder="Postal Code" (blur)="addressBlur()">
                        </mat-form-field>
                    </div>
                </fieldset>
            </fieldset>




            <div class="actions">
                <div class="formatting">

                    <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput>

                    <button mat-icon-button type="button">
                        <mat-icon [svgIcon]="'attach_file'" (click)="fileInput.click()"></mat-icon>
                    </button>
                    <label *ngIf="uploadedFile">{{ uploadedFile.name }}</label>
                    <label *ngIf="!uploadedFile">Attach file</label>

                </div>

                <div class="buttons">

                    <button class="discard-button"
                            mat-button
                            type="button"
                            (click)="discard()">
                        <span>Cancel</span>
                    </button>

                    <button class="send-button"
                        id="add-project-form-button"
                            mat-flat-button
                            type="submit"
                            [color]="'primary'"
                            [disabled]="addProjectForm.pristine || addProjectForm.invalid">
                        <span *ngIf="!addProjectForm.disabled">Save</span>
                        <mat-progress-spinner *ngIf="addProjectForm.disabled"
                                            [diameter]="24"
                                            [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>

                </div>

            </div>

        </form>
        <ng-template #optionalView>
            <div class="flex flex-wrap p-6 optional-view items-center">
                <div class="flex flex-row w-1/2 px-6 pb-0">
                    <ng-container *ngIf="lookupField('project_stage_id') as fieldDef">
                        <app-form-field [fieldDef]="fieldDef" [model]="project" (onUpdate)="updated()" [data]="options" class="w-full"></app-form-field>
                    </ng-container>
                </div>
                <ng-container *ngFor="let column of displayColumns;">
                    <ng-container *ngIf="lookupField(column) as fieldDef">
                        <div class="flex flex-row w-1/2 px-6 pb-0" *ngIf="!fieldDef.meta?.readonly">
                            <app-form-field [fieldDef]="fieldDef" [model]="project" (onUpdate)="updated()" [data]="options" class="w-full"></app-form-field>
                        </div>
                    </ng-container>
                </ng-container>
                <div class="flex justify-end actions w-full px-3">
                    <div class="buttons">
                    <button class="discard-button mr-1"
                            mat-button
                            (click)="discard()">
                        <span>Skip</span>
                    </button>

                    <button class="discard-button mr-1"
                            mat-button
                            (click)="goToDeal()">
                        <span>Go To Deal</span>
                    </button>

                    <button class="send-button"
                            id="add-project-finish-button"
                            mat-flat-button
                            [color]="'primary'"
                            (click)="discard()">
                        Finish
                    </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </mat-tab> -->
  <mat-tab label="By Url" *ngIf="isDealsDetailView">
    <form [formGroup]="addProjectByUrlForm">
      <!-- Subject -->
      <div class="flex flex-col gt-xs:flex-row mt-3">
        <mat-form-field class="subject flex-auto">
          <mat-label>Loopnet/Crexi/Zillow Url</mat-label>
          <input matInput [formControlName]="'listing_url'" />
        </mat-form-field>
      </div>
      <!-- Body -->

      <div class="actions">
        <div class="formatting"></div>

        <div class="buttons">
          <!-- Discard -->
          <button class="discard-button" mat-button type="button" (click)="discard()">
            <span>Cancel</span>
          </button>

          <!-- Send -->
          <button
            class="send-button"
            mat-flat-button
            type="submit"
            [color]="'primary'"
            [disabled]="addProjectByUrlForm.pristine || addProjectByUrlForm.invalid"
            (click)="saveByUrl()"
          >
            <span *ngIf="!addProjectByUrlForm.disabled">Save</span>
            <mat-progress-spinner
              *ngIf="addProjectByUrlForm.disabled"
              [diameter]="24"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
          </button>
        </div>
      </div>
    </form>
  </mat-tab>
  <mat-tab
    label="Google Maps"
    *ngIf="isDealsDetailView && account && (account.subdomain == 'atindustrial' || account.subdomain == 'msc')"
  >
    <form
      [formGroup]="addProjectByGoogleMapsForm"
      *ngIf="isDealsDetailView"
      (submit)="addProjectByGoogleMapsForm.pristine || addProjectByGoogleMapsForm.invalid ? null : save()"
    >
      <!-- Subject -->
      <div class="flex flex-col mt-3">
        <mat-form-field class="subject flex-auto">
          <mat-label>Deal Name</mat-label>
          <input
            id="add-project-title"
            matInput
            placeholder="Enter Deal name"
            [formControlName]="'title'"
            (blur)="onBlur()"
            (keyup.enter)="onBlur()"
          />
        </mat-form-field>
        <mat-hint *ngIf="duplicateProjects && duplicateProjects.length > 0" class="mb-3">
          One or more deals with the same name already exists:
          <ul>
            <li *ngFor="let project of duplicateProjects">
              <a class="link" (click)="goToProject(project)">{{ project.title }}</a>
            </li>
          </ul>
        </mat-hint>
      </div>
      <div class="flex flex-col gt-xs:flex-row">
        <mat-form-field class="flex-auto gt-xs:pr-3">
          <mat-label>Property Type</mat-label>
          <mat-select id="add-project-property-type" [formControlName]="'property_type_id'" placeholder="--Select--">
            <mat-option *ngFor="let propertyType of propertyTypes" [value]="propertyType.id">
              {{ propertyType.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="flex-auto gt-xs:pr-3">
          <mat-label>Deal Layout</mat-label>
          <mat-select [formControlName]="'template_id'" placeholder="--Select--">
            <mat-option *ngFor="let projectTemplate of projectTemplates" [value]="projectTemplate.id">
              {{ projectTemplate.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex flex-col gt-xs:flex-row mt-3">
        <mat-form-field class="subject flex-auto">
          <mat-label>Google Maps Url</mat-label>
          <input matInput [formControlName]="'listing_url'" />
        </mat-form-field>
      </div>

      <!-- Body -->

      <div class="actions">
        <div class="formatting">
          <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput />
          <!-- Attach file -->
          <button mat-icon-button type="button">
            <mat-icon [svgIcon]="'attach_file'" (click)="fileInput.click()"></mat-icon>
          </button>
          <label *ngIf="uploadedFile">{{ uploadedFile.name }}</label>
          <label *ngIf="!uploadedFile">Attach file</label>
        </div>

        <div class="buttons">
          <!-- Discard -->
          <button class="discard-button" mat-button type="button" (click)="discard()">
            <span>Cancel</span>
          </button>

          <!-- Send -->
          <button
            class="send-button"
            id="add-project-form-button"
            mat-flat-button
            type="submit"
            [color]="'primary'"
            (click)="saveByGoogleMapsUrl()"
            [disabled]="addProjectByGoogleMapsForm.pristine || addProjectByGoogleMapsForm.invalid"
          >
            <span *ngIf="!addProjectByGoogleMapsForm.disabled">Save</span>
            <mat-progress-spinner
              *ngIf="addProjectByGoogleMapsForm.disabled"
              [diameter]="24"
              [mode]="'indeterminate'"
            ></mat-progress-spinner>
          </button>
        </div>
      </div>
    </form>
  </mat-tab>
</mat-tab-group>
